import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// interfaces
import { IAuctionService } from '../interfaces/auction';
import { ICatalogService } from '../interfaces/catalog';
import { IProductService } from '../interfaces/product';
import { IReportService } from '../interfaces/report';
import { ILocationService } from '../interfaces/location';

// models
import { GridProperty, Product, ProductProperty } from '../models/product';
import { Report } from '../models/report';
import { ApplicationSettings } from '../models/application-settings';
import { MasterData } from '../models/master-data';
import { PublicAuction } from '../models/public-auction';
import { PublicAuctionCluster } from '../models/public-auction-cluster';
import { PublicLocation } from '../models/public-location';
import { PublicCatalog } from '../models/public-catalog';
import { SupplyForecastGeneric } from '../models/supply-forecast-generic';
import { SupplyForecastPublicUrk } from '../models/supply-forecast-public-urk';

// services
import { WebApiService } from './web-api.service';
import { Catalog, MoveLot } from '../models/catalog';
import { SupplierPublish } from '../models/supplier-publish';

@Injectable()
export class PublicDataService implements IAuctionService, ICatalogService, IReportService, IProductService, ILocationService {

  private apiPath: string;

  constructor(
    private appSettings: ApplicationSettings,
    private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi;
  }

  getPublicAuctionClustersWithForecast(): Observable<Array<PublicAuctionCluster>> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/public/forecast');
  }

  getPublicAuctionClusters(): Observable<Array<PublicAuctionCluster>> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/public');
  }


  getPublicAuctionsForCluster(auctionClusterId: number): Observable<Array<PublicAuction>> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/' + auctionClusterId + '/auction/public');
  }

  getPublicAuctions(): Observable<Array<PublicAuction>> {
    return this.webApiService.getList(this.apiPath + 'auction/public');
  }

  getPublicCatalogs(auctionId: number): Observable<Array<PublicCatalog>> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/auction/' + auctionId + '/catalog/forecast/public');
  }

  getPublicCatalogsForCluster(auctionClusterId: number): Observable<Array<PublicCatalog>> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/' + auctionClusterId + '/auction/catalog/supply/public');
  }

  getPublishedLot(auctionId: number, catalogId: number, timeZoneOffset: number, locale: string): Observable<SupplyForecastGeneric> {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/auction/' + auctionId + '/catalog/' + catalogId + '/lot/published/' + timeZoneOffset + '/' + locale); // tslint:disable-line:max-line-length
  }

  getPublicSupplyForecast(date: string, locationId: number = null): Observable<SupplyForecastPublicUrk> {
    return this.webApiService.getSingle(this.apiPath + 'publicforecast/date/' + date + '/location/' + '?locationid=' + locationId);
  }

  getPublicReports(): Observable<Array<Report>> {
    return this.webApiService.getList(this.apiPath + 'reports/public');
  }

  getPublicReport(reportId: number): Observable<Report> {
    return this.webApiService.getList(this.apiPath + 'reports/' + reportId + '/public');
  }

  getPublicMasterDataList(masterDataListId: number): Observable<MasterData> {
    return this.webApiService.getList(this.apiPath + 'masterdatalist/' + masterDataListId + '/public');
  }

  //IAuctionService

  getAuctionsForReports(auctionClusterId: number) {
    return this.webApiService.getList(this.apiPath + 'auction/public');
  }

  //ICatalogService
  getAllSupplyAndForecastCatalogsForReports(auctionClusterId: number) {
    return this.webApiService.getList(this.apiPath + 'auctioncluster/' + auctionClusterId + '/auction/catalog/supply/public');
  }

  getAllSupplyCatalogs(supplierId: number): Observable<Array<Catalog>> {
    return this.webApiService.getList(this.apiPath + `supplierlevel/${supplierId}` + '/auctioncluster/auction/catalog');
  }

  getAllForecastCatalogs(auctionClusterId: number): Observable<Array<Catalog>> {
    return;
  }

  setSupplyEditorMode(cookieService: any): boolean {
    return;
  }
  moveLots(auctionId: number, catalogId: number, destinationCatalogId: number, moveLot: MoveLot): Observable<any> {
    return;
  }

  getNumberOfLotsToMove(auctionId: number, catalogId: number, moveLot: MoveLot): Observable<any> {
    return;
  }

  //IReportService

  getReport(reportId: number) {
    return this.webApiService.getList(this.apiPath + 'reports/' + reportId + '/public');
  }

  downloadExport(reportId: number, reportRequest: any) {
  }

  requestDownload(reportId: number, reportRequest: any) {
    const url = this.apiPath + 'reports/public/requestdownload/' + reportId;
    return this.webApiService.downloadWithPost(url, reportRequest);
  }

  editReport(report: any) {
  }

  saveReport(report: any) {
  }

  getStoredProcedureValuesForProductProperty(reportId: number, filter: any) {
  }

  getStoredProcedureValuesForNumberProductProperty(reportId: number, filter: any) {
  }

  getStoredProcedureValuesForStringProductProperty(reportId: number, filter: any) {
  }

  getStoredProcedureValuesForDateProductProperty(reportId: number, filter: any) {
  }

  getEndpointValuesForProductProperty(filterEndpoint: string, filter: any) {
  }

  //IProductService
  getProductForReports(auctionClusterId: number, productId: number) {
    return null;
  }

  getProductProperties(productId: number): Observable<Array<ProductProperty>> {
    return null;
  }

  getReportProperties(productId: number, reportDesignId: number): Observable<Array<GridProperty>> {
    return null;
  }

  getProduct(auctionClusterId: number, productId: number): Observable<Product> {
    return;
  }

  publishSupplierLots(auctionId: number, catalogId: number, suppliers: SupplierPublish): Observable<any> {
    return;
  }

  //ILocationService

  getPublicLocations(auctionClusterId?: number): Observable<Array<PublicLocation>> {
   return this.webApiService.getList(this.apiPath + 'location/public');
  }
}
